import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Spinner, VStack, Text } from '@chakra-ui/react';
import CardGuessGame from '../components/CardGuessGame';

const CardGuessGamePage = () => {
  const navigate = useNavigate();

  return (
    <Suspense
      fallback={
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="rgba(0, 0, 0, 0.9)"
          zIndex={9999}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <VStack spacing={4}>
            <Spinner size="xl" color="#ffcc00" />
            <Text color="white">Caricamento gioco...</Text>
          </VStack>
        </Box>
      }
    >
      <CardGuessGame onClose={() => navigate('/')} />
    </Suspense>
  );
};

export default CardGuessGamePage;
